import {AssetLoadingFlowType, loadAssets} from "@goodgamestudios/core";

export class PokerAssetsLoader {
    public static LOADING_PRIO_LOGIN: number = 200;
    public static LOADING_PRIO_HIGH: number = 100;
    public static LOADING_PRIO_MED: number = 10;
    public static LOADING_PRIO_LOW: number = 5;
    public static LOADING_PRIO_NONE: number = 1;

    public loadDefaultAssets(): Promise<any> {
        // load default assets
        return loadAssets([
                "PokerInterface",
                "PokerMenuPanel",
                "PokerFriendsPanel",
                "PokerTableActionPanel",
                "PokerPopUpsLib",
                "PokerPopUps",
                "PokerItemLibBackgrounds2"
            ],
            AssetLoadingFlowType.SEQUENTIAL, PokerAssetsLoader.LOADING_PRIO_LOGIN);
    }

    public loadPrimaryAssets(): Promise<any> {
        // Load all of the assets needed for initialization and showing views for automatic login
        return loadAssets([
                "PokerTitle",
                "PokerBackground",
                "PokerLanguageSelection",
                "ClothesMenBasic",
                "ClothesMenNoses_Shop",
                "ClothesMenMouths_Shop",
                "ClothesMenBeards_Shop",
                "ClothesMenTies_Shop",
                "ClothesMenShoes_Shop",
                "ClothesMenEyes_Shop",
                "ClothesMenAccessories_Shop",
                "PokerItemLibGimmicks_Shop",
                "PokerItemLibPets_Shop",
                "ClothesMenMain1",
                "ClothesMenMain2",
                "ClothesMenMain3",
                "ClothesMenSecondary1",
                "ClothesMenSecondary2",
                "ClothesMenSpecial1",
                "ClothesMenSpecial2",
                "ClothesMenJewelries_Shop",
                "ClothesWomenBasic",
                "ClothesWomenMain1",
                "ClothesWomenMain2",
                "ClothesWomenMain3",
                "ClothesWomenSecondary1",
                "ClothesWomenSecondary2",
                "ClothesWomenSpecial1",
                "ClothesWomenSpecial2",
                "ClothesWomenJewelries_Shop",
                "ClothesWomenMouths_Shop",
                "ClothesWomenNoses_Shop",
                "ClothesWomenEyes_Shop",
                "ClothesWomenAccessories_Shop",
                "ClothesWomenShoes_Shop",
                "PokerTablesLib1",
                "PokerTablesLib2",
            ],
            AssetLoadingFlowType.PARALLEL, PokerAssetsLoader.LOADING_PRIO_LOGIN);
    }

    public loadSecondaryAssets(): Promise<any> {
        // load secondary assets
        return loadAssets([
                "PokerCheatsPanel",
                "PokerUIElements",
                "AvatarPreview",
                "PokerItemLib3",
                "PokerItemLibBackgrounds1",
                "PokerItemLibBackgrounds3",
                "PokerItemLibBackgrounds4",
                "PokerItemLibBackgrounds5",
                "PokerItemLibBackgrounds6",
                "PokerItemLibBackgrounds7",
                "PokerItemLibOther",
                "PokerStarterPackages",
                "PokerTeaser",
                "PokerTutorial",
                "PokerTable",
                "PokerBandit",
                "PokerItemLib1",
                "PokerItemLibCards",
                "PokerItemLibAchievements",
                "PokerItemLibPets",
                "PokerItemLibGiftsSpecial",
                "PokerItemLibGiftsFood",
                "PokerItemLibGiftsExtra",
                "PokerItemLibGimmicks"
            ],
            AssetLoadingFlowType.PARALLEL, PokerAssetsLoader.LOADING_PRIO_LOW);
    }
}
